<template>
  <div class="new-activity" ref="newActivity">
    <div class="header-fixed">
      <div class="item" :class="{active: headerActive===1}" @click="headerTabChange(1)"><span class="text">食品</span><span class="line"></span></div>
      <div class="item" :class="{active: headerActive===2}" @click="headerTabChange(2)"><span class="text">酒类</span><span class="line"></span></div>
      <div class="item" :class="{active: headerActive===3}" @click="headerTabChange(3)"><span class="text">礼包</span><span class="line"></span></div>
      <div class="item" :class="{active: headerActive===4}" @click="headerTabChange(4)"><span class="text">家用</span><span class="line"></span></div>
    </div>
    <div class="annual-goods-header"></div>
    <div class="goods-con">
      <div class="classification-item" v-for="i in 4">
        <div class="classification-header" :ref="`itemHeader${i}`" :class="`item${i}-header`"></div>
        <div class="goods-list">
          <annual-goods v-for="(item, i) in list['items'+i]" :key="i" :itemData="item"></annual-goods>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters} from 'vuex';
import { mallGoods } from '@/api/mall/mallGoods'
import annualGoods from './components/annualGoods/index'
export default {
  components: {
    annualGoods,
  },
  data() {
    return {
      page: 1,
      size: 200,
      list:{
        items1: [],
        items2: [],
        items3: [],
        items4: [],
      },
      headerActive: 1,
      el: {
        itemHeader1: null,
        itemHeader2: null,
        itemHeader3: null,
        itemHeader4: null
      },
      itemHeight: {
        height1: 0,
        height2: 0,
        height3: 0,
        height4: 0
      },
    }
  },
  computed:{
    ...mapGetters([
      'h5Config',
    ]),
  },
  created() {
    document.title = '年货节主会场'
    // this.getGoodsList({item: 1, level: 1, id: 10686});
    // this.getGoodsList({item: 2, level: 1, id: 10706});
    // this.getGoodsList({item: 3, level: 1, id: 10699});
    // this.getGoodsList({item: 4, level: 1, id: 10681});

    Promise.all([
      this.getGoodsList({item: 1, level: 1, id: 10686}),// 食品饮料
      this.getGoodsList({item: 2, level: 1, id: 10706}),// 酒类
      this.getGoodsList({item: 3, level: 1, id: 10699}),// 医药保健
      this.getGoodsList({item: 4, level: 1, id: 10681}) // 家用电器
    ]).then(resList=>{
      // console.log('resList', resList)
      window.setTimeout(()=>{
        resList.forEach((item, i)=>{
          // this.el['itemHeader'+(i+1)] = this.$refs['itemHeader'+(i+1)][0]
          this.itemHeight['height'+(i+1)] = this.$refs['itemHeader'+(i+1)][0].offsetTop + 446.5-84
        })
        this.$refs.newActivity.addEventListener('scroll', this.newActivityScroll)
      },200)



    })
  },
  methods: {
    getGoodsList(obj) {
      let req = {
        goodsType: 'JD_GOODS',
        orderBy: 'SPRING_FESTIVAL_SPECIALS',
        // sortOrder: 'DESC',
        page: this.page,
        size: this.size,
      }
      if(obj.level===1){req.goodsCategorySysIdFirst = obj.id}
      if(obj.level===2){req.goodsCategorySysIdSecond = obj.id}
      if(obj.level===3){req.goodsCategorySysIdThird = obj.id}
      return mallGoods(req).then(res=>{
        this.list['items'+ obj.item] = res.data.items || []
        return this.list['items'+ obj.item]
      })
    },

    headerTabChange(tab){
      this.headerActive = tab;
      this.$refs.newActivity.scrollTop = this.itemHeight['height'+tab]
    },

    newActivityScroll(){
      let top = this.$refs.newActivity.scrollTop
      if(top>0){
        this.headerActive = 1
      }
      if(top>(this.itemHeight.height2-1)){
        this.headerActive = 2
      }
      if(top>(this.itemHeight.height3-1)){
        this.headerActive = 3
      }
      if(top>(this.itemHeight.height4-1)){
        this.headerActive = 4
      }

    },

  }
}
</script>

<style lang="less" scoped>
@url: 'https://fileqn.anttalk.vip/';
.new-activity{
  position: relative;width: 100%;height: 100%;overflow: auto;
  background: rgb(184,33,34);
  .header-fixed{
    display: flex;justify-content: center;align-items: center;padding: 0 68px;
    width: 100%;height: 44px;position: fixed;z-index: 1;background: rgba(184,33,34,1);
    .item{
      display: inline-flex;flex: 1;justify-content: center;align-items: center;
      position: relative;z-index: 0;height: 100%;
      .text{
        color: #ffdcdc;font-size: 14px;
      }
      .line{

      }
      &.active{
        .text{
          color: #fff;font-weight: bold;
        }
        .line{
          position: absolute;width: 15px;height: 2px;
          bottom: 6px;left: 23px;border-radius: 4px;
          background: #fff;
        }
      }
    }
  }
  .annual-goods-header{
    width: 100%;height: 402.5px;margin-top: 44px;
    background: url("@{url}Fr3avEblSuM2FSWkJ08LNv0c7EDK") no-repeat 50% 50%;
    background-size: 100%;
  }
  .goods-con{
    position: relative;top: -44px;
    .classification-item{
      .classification-header{
        width: 100%;height: 50px;
        &.item1-header{
          background: url("@{url}FnSoxlWLYLZVuNtCdYbkqbgA-yDW") no-repeat 50% 50%;
          background-size: 193.5px 34px;
        }
        &.item2-header{
          background: url("@{url}FlTWmgsA6oeOUl3WVWnkYS-Ek7YY") no-repeat 50% 50%;
          background-size: 193.5px 34px;
        }
        &.item3-header{
          background: url("@{url}FsswEGxftGX61cjjykN1S7hzSvMo") no-repeat 50% 50%;
          background-size: 193.5px 34px;
        }
        &.item4-header{
          background: url("@{url}FivohUfVQ5HinwMhakAOREQq9ZSf") no-repeat 50% 50%;
          background-size: 193.5px 34px;
        }

      }
      .line{
        width: 351px;height: 1px;background: #ffdba3;margin: auto;
      }
    }
    .goods-list{
      display: flex;justify-content: flex-start;flex-wrap: wrap;
    }
  }
}
</style>